export default class OfferingPrice {
    static fromData(data, duplicate = false) {
        if (!data) {
            return;
        }

        let offeringPrice = new OfferingPrice();

        offeringPrice.id = data.id || null;
        if (duplicate) {
            offeringPrice.id = null;
        }
        offeringPrice.clubFee = data.clubFee;
        offeringPrice.department = data.department;
        offeringPrice.divergentAmount = data.divergentAmount;
        offeringPrice.team = data.team;
        offeringPrice.type = data.type;

        Object.seal(offeringPrice);
        return offeringPrice;
    }

    equals(offeringPrice){
        if (offeringPrice.id === null) {
            return false;
        }
        return offeringPrice.id === this.id;
    }
}
